$(function(){
    function cps4(obj){
        $('.cps4si').removeClass('select');
        $('.cps4li').removeClass('select');

        $(obj).addClass('select');

        $('.cps4 .cps4si').each(function(i,e){
            if($(e).hasClass('select')){
                $('.cps4li').eq(i).addClass('select')
            }
        })
    }
    $('.cps4 .cps4si').hover(function(){
        cps4(this);
    });
    $('.cps4 .cps4si').click(function(){
        cps4(this);
    });
});